import axios from 'axios';

import { requestInterceptor } from './interceptors/requestInterceptor';
import {
  responseErrorInterceptor,
  responseSuccessInterceptor,
} from './interceptors/responseInterceptor';

/**
 * Main axios instance for API calls
 *
 * Configuration:
 * - Base URL from environment
 * - 30s timeout
 * - JSON content type
 *
 * Interceptors:
 * - Request: Adds Bearer token + subscription key
 * - Response: Handles 401 with token refresh
 */
export const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_WEBAPI_DOTNET_URI,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
  // Serializes arrays as comma-separated values; non-primitive/non-array values are intentionally skipped.
  paramsSerializer: (params: Record<string, unknown>): string => {
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (value === undefined || value === null) continue;
      if (Array.isArray(value)) {
        searchParams.set(key, value.join(','));
      } else if (
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean'
      ) {
        searchParams.set(key, String(value));
      }
    }
    return searchParams.toString();
  },
});

// Add interceptors
axiosInstance.interceptors.request.use(requestInterceptor, error =>
  Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  responseSuccessInterceptor,
  responseErrorInterceptor
);
